import LegalLayout from './LegalLayout';

const CGVPage = () => (
  <LegalLayout title="Conditions Générales de Vente">
    <p data-testid="legal-cgv-intro">
      Les présentes Conditions Générales de Vente (ci-après « CGV ») régissent les relations
      contractuelles entre <strong>Ô'Délicieuse SRL</strong>, dont le siège social est situé
      Rue Marie-Christine 32, 1020 Bruxelles (Belgique), ci-après « le Vendeur », et toute
      personne souhaitant effectuer un achat via le site <strong>odelicieuse.eu</strong>,
      ci-après « le Client ». Notre activité s'adresse à titre principal à une clientèle
      professionnelle (B2B — revendeurs, grossistes).
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">1. Acceptation des CGV</h2>
    <p>
      Toute commande passée sur le site implique l'acceptation sans réserve par le Client des
      présentes CGV. Le Client reconnaît avoir la capacité juridique pour contracter.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">2. Produits</h2>
    <p>
      Les produits proposés à la vente sont ceux figurant sur le site, dans la limite des stocks
      disponibles. Les caractéristiques essentielles (nom, marque, catégorie, image) sont
      présentées sur chaque fiche produit. Les photographies sont non contractuelles.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">3. Prix et paliers tarifaires</h2>
    <p>
      Les prix sont indiqués en euros, toutes taxes comprises (TVAC) applicables en Belgique.
      Trois paliers tarifaires s'appliquent automatiquement en fonction du nombre total
      d'articles présents dans le panier :
    </p>
    <ul className="list-disc pl-6 space-y-1">
      <li><strong>Détail</strong> : moins de 12 articles — prix conseillé de revente</li>
      <li><strong>Semi-gros</strong> : à partir de 12 articles</li>
      <li><strong>Gros</strong> : à partir de 60 articles</li>
    </ul>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">4. Commande</h2>
    <p>
      La commande est passée via le site en sélectionnant les produits souhaités dans le panier,
      puis en confirmant via WhatsApp. Un accusé de réception est transmis par message. Le
      Vendeur se réserve le droit de refuser ou d'annuler toute commande en cas d'indisponibilité
      produit, de litige de paiement antérieur, ou en cas de motif légitime.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">5. Validation du compte client</h2>
    <p>
      Chaque nouveau compte client est soumis à une <strong>validation manuelle préalable</strong>{' '}
      par notre équipe. Une notification par email vous sera envoyée dès que votre compte sera
      approuvé. Cette validation est notamment requise pour accéder aux tarifs professionnels.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">6. Paiement</h2>
    <p>
      Le paiement s'effectue selon les modalités convenues par WhatsApp avec notre équipe :
      virement bancaire, espèces à la livraison (selon accord), ou autres moyens acceptés à la
      discrétion du Vendeur. La commande n'est définitivement confirmée qu'après réception du
      paiement ou accord explicite de notre équipe.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">7. Livraison</h2>
    <p>
      Les livraisons sont principalement effectuées en Belgique. Les délais de livraison sont
      donnés à titre indicatif et confirmés lors de l'échange WhatsApp. Un retard éventuel ne
      pourra donner lieu à résiliation de la commande ou à indemnité. Le transfert des risques
      s'effectue à la remise des marchandises au Client ou à son transporteur.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">8. Livraison partielle</h2>
    <p>
      En cas de rupture partielle de stock, le Vendeur peut, après accord du Client, livrer
      uniquement les quantités disponibles. Le montant de la commande est alors recalculé en
      conséquence.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">9. Retours, réclamations et garanties</h2>
    <p>
      Toute réclamation relative à un produit (défaut, erreur de commande, casse) doit être
      formulée dans un délai de <strong>48 heures</strong> suivant la réception, par WhatsApp
      ou email, accompagnée de photographies. Passé ce délai, aucune réclamation ne pourra être
      acceptée. Les produits retournés ne sont repris que s'ils sont non ouverts, non utilisés
      et dans leur emballage d'origine.
    </p>
    <p>
      <strong>Clientèle particulière (B2C) :</strong> conformément au Livre VI du Code de droit
      économique belge, le consommateur dispose d'un droit de rétractation de{' '}
      <strong>14 jours calendaires</strong> à compter de la réception. La rétractation doit
      nous être notifiée par écrit. Les frais de retour sont à charge du Client. Ce droit ne
      s'applique pas aux produits descellés pour raisons d'hygiène (parfums ouverts).
    </p>
    <p>
      <strong>Clientèle professionnelle (B2B) :</strong> le droit de rétractation de 14 jours
      ne s'applique pas aux ventes entre professionnels.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">10. Responsabilité</h2>
    <p>
      Le Vendeur ne saurait être tenu responsable des dommages résultant d'une mauvaise
      utilisation des produits ou d'un usage non conforme à leur destination. Notre
      responsabilité est, en tout état de cause, limitée au montant de la commande concernée.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">11. Propriété intellectuelle</h2>
    <p>
      Les marques citées demeurent la propriété de leurs titulaires respectifs. Le site et son
      contenu sont protégés par le droit de la propriété intellectuelle.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">12. Données personnelles</h2>
    <p>
      Le traitement des données personnelles est détaillé dans notre{' '}
      <a href="/confidentialite" className="text-[color:var(--color-primary)] hover:underline">
        politique de confidentialité
      </a>
      .
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">13. Litiges et droit applicable</h2>
    <p>
      Les présentes CGV sont soumises au droit belge. En cas de litige, une solution amiable
      sera recherchée en priorité. À défaut, les tribunaux de Bruxelles seront seuls compétents,
      sauf disposition légale impérative contraire en faveur du consommateur.
    </p>

    <p className="text-xs text-muted mt-8 italic">
      Dernière mise à jour : {new Date().toLocaleDateString('fr-BE', { day: '2-digit', month: 'long', year: 'numeric' })}.
    </p>
  </LegalLayout>
);

export default CGVPage;
